import { render, staticRenderFns } from "./personage.vue?vue&type=template&id=6efc4512&scoped=true"
import script from "./personage.vue?vue&type=script&lang=js"
export * from "./personage.vue?vue&type=script&lang=js"
import style0 from "./personage.vue?vue&type=style&index=0&id=6efc4512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc4512",
  null
  
)

export default component.exports